<ng-container *ngIf="(cmsLabels$ | async)?.labels?.stellar?.ok">
    <div class="min-h-dvh w-full max-w-[636px] !overflow-x-hidden">
            <div class="flex flex-col w-full h-full px-6">
            <div>
                <app-sign-in-header [cmsLabels$]="cmsLabels$" [languageList]="languageList" [displayBackButton]="displayBackButton()" (backButtonClickEvent)="handleBackButton()"></app-sign-in-header>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 0, 'h-full': currentStep === 0}">
                <div *ngIf="currentStep === 0"></div>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 1, 'h-full': currentStep === 1}">
                <app-request-otp #requestOtpComponent (requestOtpEvent)="handleRequestOTPEvent($event)" [isRecaptchaSolved]="isRecaptchaSolved" [cmsLabels]="cmsLabels"></app-request-otp>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 2, 'h-full': currentStep === 2}">
                <app-submit-otp #submitOtpComponent [phoneNumber]="userPhoneNumber" [dialCode]="userDialCode" [iso2Code]="userPhoneIso2Code" [initialCountdownInSeconds]="resetOtpTimerInSec" [cmsLabels]="cmsLabels" (submitOtpEvent)="verifyOtp($event)" (requestNewOtpEvent)="resendOtp()"></app-submit-otp>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 3, 'h-full': currentStep === 3}">
                <app-register-email #registerEmailComponent [cmsLabels]="cmsLabels" (submitEmailEvent)="handleSubmitEmailEvent($event)"></app-register-email>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 4, 'h-full': currentStep === 4}">
                <app-user-profile [countries]="countries$ | async" [cmsLabels]="cmsLabels" (notifyUserRegistration)="onNotifyUserRegistration($event)"></app-user-profile>
            </div>
            <div [ngClass]="{'hidden': currentStep !== 5, 'h-full': currentStep === 5}">
                <app-risk-sdk *ngIf="riskStatus && riskStatus?.journeyToken && riskStatus?.journeyKey" [riskStatus]="riskStatus" [currentStep]="currentStep" [steps]="steps" [cmsLabels]="cmsLabels" (riskSdkCompleteEvent)="handleRiskSdkCompleteEvent()"></app-risk-sdk>
            </div>
        </div>
    </div>
</ng-container>


